export var headlineLarge = {
    fontSize: 'var(--encore-text-size-larger-5)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 800,
};
export var headlineMedium = {
    fontSize: 'var(--encore-text-size-larger-4)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
export var titleLarge = {
    fontSize: 'var(--encore-text-size-larger-3)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
export var titleMedium = {
    fontSize: 'var(--encore-text-size-larger-2)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
export var titleSmall = {
    fontSize: 'var(--encore-text-size-larger)',
    fontFamily: 'SpotifyMixUITitle,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
export var bodyMedium = {
    fontSize: 'var(--encore-text-size-base)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 400,
};
export var bodyMediumBold = {
    fontSize: 'var(--encore-text-size-base)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
export var bodySmall = {
    fontSize: 'var(--encore-text-size-smaller)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 400,
};
export var bodySmallBold = {
    fontSize: 'var(--encore-text-size-smaller)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
export var marginal = {
    fontSize: 'var(--encore-text-size-smaller-2)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 400,
};
export var marginalBold = {
    fontSize: 'var(--encore-text-size-smaller-2)',
    fontFamily: 'SpotifyMixUI,CircularSp-Arab,CircularSp-Hebr,CircularSp-Cyrl,CircularSp-Grek,CircularSp-Deva',
    fontWeight: 700,
};
